export type DiceSpeed = 'SLOW' | 'NORMAL' | 'FAST';

export const SPEED_MAP: Record<DiceSpeed, number> = {
  SLOW: 1.5,
  NORMAL: 1,
  FAST: 0.5,
};

export const SPEED_OPTIONS: DiceSpeed[] = ['SLOW', 'NORMAL', 'FAST'];
